module.exports = __webpack_public_path__ + "static/media/query-trucks.7dfd7dee.jpg";